export const spritz = {
  data() {
    return {
      words: '',
      currentWord: '',
      spritzTimer: '',
      pause: false
    }
  },
  props: {},
  computed: {
    ms_per_word() {
      return 60000 / +this.params.speed;
    }
  },
  methods: {
    stopSpritzTimer() {
      clearInterval(this.spritzTimer);
      this.timer = {
        total: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
    },
    startReading() {
      let timer;
      let words = this.words;
      let app = this;

      function reading(currentWord = 0) {
        console.log('reading');
        if (currentWord >= words.length || !app.params.start) {
          console.log('finish');
          app.params.finish = true;
          app.addScores();
          app.makeStats();
          return;
        } else {
          //console.log('timeout');
          if (!app.pause) {
            let word = app.words[currentWord];
            app.currentWord = app.prepareWord(word);
            currentWord++;
          }
          timer = setTimeout(reading, app.ms_per_word, currentWord);
        }
      }

      reading();
    },
    startReading2() {
      let words = this.words;
      let currentWord = 0;
      if (words.length > 0) {
        this.spritzTimer = setInterval(() => {
          //updateValues(currentWord);
          //console.log(words[currentWord]);
          this.currentWord = words[currentWord];
          currentWord++;
          if (currentWord >= words.length) {
            currentWord = 0;
            this.stopSpritzTimer();
          }
        }, this.ms_per_word);
      }
    },
    prepareText() {
      let raw = this.params.text.desc;
      let text = raw.replace(/(\r\n|\n|\r)/gm, " ");
      let words = this.stringToWordsArray(text);
      this.words = words;
      //console.log(words);
    },
    prepareWord(word) {
      //console.log(word);

      let length = word.length;

      let redLetter = 1;
      switch (length) {
        case 1:
          redLetter = 1;
          break;
        case 2:
        case 3:
        case 4:
        case 5:
          redLetter = 2;
          break;
        case 6:
        case 7:
        case 8:
        case 9:
          redLetter = 3;
          break;
        case 10:
        case 11:
        case 12:
        case 13:
          redLetter = 4;
          break;
        default:
          redLetter = 5;
      }

      //console.log(redLetter);

      let start = ' '.repeat((11 - redLetter)) + word.slice(0, redLetter - 1);
     //console.log('start', start);
      let middle = word.slice(redLetter - 1, redLetter);
      //console.log('middle', middle);
      let fin_dots = 11 - (word.length - redLetter);
      let end = word.slice(redLetter, length) + ' '.repeat(fin_dots > 0 ? fin_dots : 0);
      //console.log(start, middle, end);
      return {
        start, middle, end
      }
    },
    /* Преобразуем строку в массив слов */
    stringToWordsArray(str) {
      return str.split(' ');
    },

    startApp() {
      this.params.start = true;
      this.prepareText();
      this.startReading();
    }
  },
  mounted() {
    //this.startApp();
  }
};